import { EVERYTHING_INVOICED_MESSAGE, invoiceableLines } from './invoiceableLines';
import type { SoldItemsQuery, SoldLines } from '../types/agreements.types';

export type InvoicingView = 'previously_invoiced' | 'create';

export interface InvoicingViewInputs {
    canBrowseInvoices: boolean;
    canAddInvoice: boolean;
    invoicesLoading: boolean;
    invoicesError: boolean;
    invoiceCount: number;
}

export const NOTHING_SOLD_MESSAGE = 'No lines were sold on this agreement.';

export function initialInvoicingView({
    canBrowseInvoices,
    canAddInvoice,
    invoicesLoading,
    invoicesError,
    invoiceCount,
}: InvoicingViewInputs): InvoicingView | 'loading' {
    if (!canBrowseInvoices) return 'create';
    if (invoicesLoading) return 'loading';
    if (invoicesError || invoiceCount > 0 || !canAddInvoice) return 'previously_invoiced';
    return 'create';
}

export function createInvoiceDisabledReason(lines: SoldLines | undefined): string | null {
    if (!lines) return null;
    const left = invoiceableLines(lines);
    if (left.services.length > 0 || left.addOns.length > 0) return null;
    const soldLineCount = lines.addOns.length + lines.services.reduce((count, service) => count + service.items.length, 0);
    return soldLineCount === 0 ? NOTHING_SOLD_MESSAGE : EVERYTHING_INVOICED_MESSAGE;
}

export function settledSoldLines({
    data,
    isLoading,
    isError,
}: Pick<SoldItemsQuery, 'data' | 'isLoading' | 'isError'>): SoldLines | undefined {
    return isLoading || isError ? undefined : data;
}
